import { withDependencies, named, optional } from '@wix/thunderbolt-ioc'
import {
	SiteFeatureConfigSymbol,
	IAppWillMountHandler,
	HeadContentSymbol,
	IHeadContent,
} from '@wix/thunderbolt-symbols'
import type { IMpaNavigation } from 'feature-mpa-navigation'
import { MpaNavigationSymbol } from 'feature-mpa-navigation'
import type { SpeculationRulesSiteConfig, SpeculationRulesConfig } from './types'
import { name } from './symbols'

/**
 * Adds speculation rules to the head when MPA navigation is eligible and the experiment is enabled
 */
export const SpeculationRules = withDependencies(
	[named(SiteFeatureConfigSymbol, name), HeadContentSymbol, optional(MpaNavigationSymbol)],
	(
		siteFeatureConfig: SpeculationRulesSiteConfig,
		headContent: IHeadContent,
		mpaNavigation?: IMpaNavigation
	): IAppWillMountHandler => {
		return {
			async appWillMount() {
				// Feature will not be enabled if false, so this isn't strictly necessary, leaving in in case we want to add logic and for tests
				if (!siteFeatureConfig.isMpaSpeculationRulesEnabled) {
					return
				}

				// Check if MPA navigation is eligible
				const isMpaEligible = mpaNavigation?.isEligible() ?? false

				if (isMpaEligible) {
					const speculationRulesConfig: SpeculationRulesConfig = {
						prefetch: [
							{
								where: { href_matches: '/*' },
								eagerness: 'moderate',
							},
						],
					}

					headContent.setHead(
						`<script type="speculationrules">${JSON.stringify(speculationRulesConfig)}</script>`
					)
				}
			},
		}
	}
)
